var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#1F3BB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.784 31.888H19.596L17.796 37H12.432L21.792 11.872H27.588L36.912 37H31.548L29.784 31.888ZM28.416 28.036L24.672 17.308L20.928 28.036H28.416Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logo-mini.37bb32409e1bcbea1d3a1d9dae5acaec.svg";
export { ForwardRef as ReactComponent };